















import {Component} from "vue-property-decorator";
import {KundeService} from "../../services/kunde-service";
import {Kunde} from "../../models/kunde-model";
import {ErrorBag, Validator} from "vee-validate";
import router from "../../router";
import BtFormGroup from '../../components/BtFormGroup.vue';
import BtChoser from '../../components/bt-choser/BtChoser.vue';
import {GlobalHelper} from "../../helper/global-helper";
import EditPageBase from "@/views/Generic/EditPageBase.vue";
import {UserStore} from "@/store/modules/currentuser-store";
import {LookupModule, LookupStore} from "@/store/modules/lookup-store";
import Zusatzfunktionen from './Zusatzfunktionen.vue';

@Component({
    components: {BtChoser, BtFormGroup, Zusatzfunktionen}
})
export default class KundeEdit extends EditPageBase {
    private kundeService!: KundeService;
    public kunde: Kunde = new Kunde();
    public errors!: ErrorBag;
    public $validator!: Validator;
    public loading: boolean = true;
    private sending: boolean = false;
    public lookupStore: LookupModule = LookupStore;

    created() {
        this.kundeService = new KundeService();
    }

    async mounted() {
        this.kunde = await this.kundeService.GetById(this.$store.state.user.currentUser.KundeId);

        this.loading = false;
        await this.$nextTick();
        this.enableWatch('kunde');            
    }

    get currentId(){
        return this.kunde.Id;
    }        

    async onSubmit(event: any) {
        try {
            event.preventDefault();
            await this.$validator.validateAll();                              
            if (this.errors.count() == 0) {                   
                this.sending = true;
                this.disableWatch();
                await this.kundeService.Put(this.kunde);
                this.dirty = false;
                GlobalHelper.NotifySuccess();
                await UserStore.ensureCurrentData(true); //TODO: wenn aktueller Kunde geändert wird, dann werden seine Properties neu geladen (Achtung bei Kunden in anderem Tab)
                router.push('/verwaltung/zusatzfunktionen');
            } else {
                GlobalHelper.NotifyError(this.$t('Allgemein.Pflichtfeld nicht ausgefüllt.').toString());
            }
        } catch (e) {
            console.log(e);
        } finally {
            this.sending = false;
        }
    }

}
